<section
  class="version-attribute-search"
  [class.version-attribute-search--compact]="compact"
  [class.version-attribute-search--association]="isAssociationLayout"
  [class.version-attribute-search--versions-list]="isVersionsListLayout">
  @if (!isAssociationLayout && !isVersionsListLayout) {
    <header class="version-attribute-search__header">
      <h3 class="version-attribute-search__title">Filter Versions by Inherited Store Attributes</h3>
      @if (totalVersionCount) {
        <p class="version-attribute-search__subtitle">
          {{ totalVersionCount }} version{{ totalVersionCount === 1 ? '' : 's' }} in division
        </p>
      }
    </header>
  }

  @if (categoriesLoading) {
    <p class="categories-loading">
      Loading store attribute filters...
    </p>
  }

  @if (!categoriesLoading && categoriesLoadError) {
    <p class="categories-load-error">
      Could not load store attribute filters. Please refresh and try again.
    </p>
  }

  @if (!categoriesLoading && !categoriesLoadError && categories.length) {
    <!-- Versions-list layout (mockup style) -->
    @if (isVersionsListLayout) {
      <div class="filter-panel" [formGroup]="filterForm">
        <h4 class="filter-panel__title">&#128269; Filter Versions by Inherited Store Attributes</h4>
        @for (category of categories; track category) {
          <div class="filter-section">
            <div class="filter-section-label">
              <span class="dot" [ngClass]="getCategoryDotClass(category.color)"></span>
              {{ category.name }}
            </div>
            @if (categoryUsesOnlySelects(category)) {
              <div class="filter-row">
                @for (field of category.fields; track field) {
                  <div class="filter-group">
                    <label>{{ getFilterFieldDisplayName(field) }}</label>
                    <select [formControl]="getControl(field.clientKey)">
                      <option [ngValue]="null">All {{ getFilterFieldDisplayName(field) }}</option>
                      @for (option of getSelectOptions(field); track option.value) {
                        <option [ngValue]="option.value">
                          {{ option.label }}
                        </option>
                      }
                    </select>
                  </div>
                }
              </div>
            }
            @if (categoryUsesOnlyMultiSelects(category)) {
              <div class="filter-row">
                @for (field of category.fields; track field) {
                  <div class="filter-group">
                    <label>{{ getFilterFieldDisplayName(field) }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                      <mat-select [formControl]="getControl(field.clientKey)" multiple>
                        @for (option of field.options; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
              </div>
            }
            @if (!categoryUsesOnlySelects(category) && !categoryUsesOnlyMultiSelects(category) && categoryUsesOnlyBooleans(category)) {
              <div class="filter-checkboxes">
                @for (field of category.fields; track field) {
                  <label class="filter-check">
                    <input type="checkbox" [formControl]="getControl(field.clientKey)" />
                    {{ field.name }}
                  </label>
                }
              </div>
            }
            @if (!categoryUsesOnlySelects(category) && !categoryUsesOnlyMultiSelects(category) && !categoryUsesOnlyBooleans(category)) {
              <div class="filter-row filter-row--mixed">
                @for (field of category.fields; track field) {
                  @if (field.valueType === singleSelectType) {
                    <div class="filter-group">
                      <label>{{ getFilterFieldDisplayName(field) }}</label>
                      <select [formControl]="getControl(field.clientKey)">
                        <option [ngValue]="null">All {{ getFilterFieldDisplayName(field) }}</option>
                        @for (option of getSelectOptions(field); track option.value) {
                          <option [ngValue]="option.value">
                            {{ option.label }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (field.valueType === multiSelectType) {
                    <div class="filter-group">
                      <label>{{ getFilterFieldDisplayName(field) }}</label>
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                        <mat-select [formControl]="getControl(field.clientKey)" multiple>
                          @for (option of field.options; track option) {
                            <mat-option [value]="option">
                              {{ option }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (field.valueType === booleanType) {
                    <label class="filter-check">
                      <input type="checkbox" [formControl]="getControl(field.clientKey)" />
                      {{ field.name }}
                    </label>
                  }
                  @if (field.valueType === textType) {
                    <div class="filter-group">
                      <label>{{ getFilterFieldDisplayName(field) }}</label>
                      <input type="text" [formControl]="getControl(field.clientKey)" />
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
        <div class="filter-active-tags">
          @if (hasAppliedFilters) {
            <span class="filter-results-count">
              Showing {{ searchSummary.matchingVersions }} of {{ totalVersionCount || searchSummary.matchingVersions }} versions
            </span>
          }
          @if (!hasAppliedFilters && hasActiveFilters) {
            <span class="filter-results-count">
              {{ activeSelections.length }} filter{{ activeSelections.length === 1 ? '' : 's' }} selected
            </span>
          }
          @if (!hasActiveFilters) {
            <span class="filter-results-count">
              Select filters above, then click Filter
            </span>
          }
          @if (hasActiveFilters) {
            <span class="filter-active-tags__sep">|</span>
          }
          @for (selection of activeSelections; track selection) {
            <span
              class="filter-tag-removable"
              [ngClass]="getCategoryTagClass(selection.categoryColor)">
              {{ selection.label }}: {{ selection.displayValue }}
              <span class="x" (click)="removeFilter(selection.clientKey)">x</span>
            </span>
          }
          <button type="button" class="btn btn-sm btn-primary filter-btn" [disabled]="!hasActiveFilters" (click)="applyFilters()">
            Filter
          </button>
          <button type="button" class="btn btn-sm btn-outline clear-all-btn-vl" (click)="clearAll()">
            Clear All
          </button>
        </div>
      </div>
      @if (hasAppliedFilters) {
        <div class="stats-row">
          <div class="stat-card">
            <div class="stat-value">{{ searchSummary.matchingVersions }}</div>
            <div class="stat-label">Matching Versions</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ searchSummary.fullMatch }}</div>
            <div class="stat-label">Full Match</div>
          </div>
          <div class="stat-card">
            <div class="stat-value stat-value--warning">{{ searchSummary.partialMatch }}</div>
            <div class="stat-label">Partial Match</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ searchSummary.totalStores }}</div>
            <div class="stat-label">Total Stores</div>
          </div>
        </div>
      }
      @if (hasAppliedFilters) {
        <div class="card results-card">
          <div class="card-header">
            <span>{{ filteredResultsTitle }}</span>
            <span class="card-header__sort">Sorted: full matches first</span>
          </div>
          @if (attributeSearchLoading) {
            <p class="results-loading">Loading matching versions...</p>
          }
          @if (!attributeSearchLoading) {
            @if (apiResults.length === 0) {
              <p class="no-results-message">
                No versions match the selected filters.
              </p>
            }
            @for (result of fullMatchResults; track result.versionName) {
              <div class="version-item">
                <div class="conflict-icon conflict-ok" [matTooltip]="getMatchTooltip(result)" matTooltipPosition="above">
                  &#10003;
                </div>
                <div class="version-code">{{ result.versionName }}</div>
                <div class="version-tags">
                  @for (tag of result.inheritedAttributes; track tag) {
                    <span
                      class="tag"
                      [ngClass]="getTagClass(tag.categoryColorHex)">
                      {{ formatTagLabel(tag) }}
                    </span>
                  }
                </div>
                <div class="version-meta">
                  {{ result.storeCount }} stores<br />
                  <span class="version-meta__match version-meta__match--full">{{ result.matchPercent }}% match</span>
                </div>
              </div>
            }
            @if (partialMatchResults.length) {
              <div class="partial-matches-banner">
                &#9888; Partial Matches - cross-state or mixed-capability versions (review before selecting)
              </div>
            }
            @for (result of partialMatchResults; track result.versionName) {
              <div class="version-item version-item--partial">
                <!-- <div class="version-checkbox"></div> -->
                <div
                  class="conflict-icon conflict-warn conflict-warn--clickable"
                  [matTooltip]="getMatchTooltip(result)"
                  matTooltipPosition="above"
                  (click)="toggleConflictDetail(result, $event)">
                  !
                </div>
                <div class="version-code">{{ result.versionName }}</div>
                <div class="version-tags">
                  @for (tag of result.inheritedAttributes; track tag) {
                    <span
                      class="tag"
                      [ngClass]="getTagClass(tag.categoryColorHex)">
                      {{ formatTagLabel(tag) }}
                    </span>
                  }
                </div>
                <div class="version-meta">
                  {{ result.storeCount }} stores<br />
                  <span class="version-meta__match version-meta__match--partial">{{ result.matchPercent }}% match</span>
                </div>
              </div>
              @if (isConflictDetailExpanded(result) && eventId) {
                <app-version-conflict-detail-panel
                  [eventId]="eventId"
                  [versionId]="result.versionId!"
                  [versionName]="result.versionName"
                  [appliedFilters]="appliedSelections"
                  [filterPairs]="appliedFilterPairs"
                  [showActions]="false">
                </app-version-conflict-detail-panel>
              }
            }
          }
        </div>
      }
    } @else {
      <div [class.filter-panel-card]="isAssociationLayout">
        @if (isAssociationLayout) {
          <header class="version-attribute-search__header">
            <h3 class="version-attribute-search__title">Filter by Inherited Store Attributes</h3>
          </header>
        }
        <div class="version-attribute-search__panel" [formGroup]="filterForm">
          @for (category of categories; track category) {
            <div
              class="category-block"
              [class.category-block--boolean]="isAssociationLayout && categoryUsesOnlyBooleans(category)">
              <div class="category-header" [style.--cat-color]="category.colorHex">
                <span class="category-dot"></span>
                <span
                  class="category-name"
                  [style.color]="isAssociationLayout ? category.colorHex : null">
                  {{ category.name | uppercase }}
                </span>
              </div>
              <div
                class="filter-grid"
                [class.filter-grid--association]="isAssociationLayout"
                [class.filter-grid--association-select]="isAssociationLayout && !categoryUsesOnlyBooleans(category)"
                [class.filter-grid--boolean]="isAssociationLayout && categoryUsesOnlyBooleans(category)">
                @for (field of category.fields; track field) {
                  <div class="filter-cell">
                    @switch (field.valueType) {
                      @case (booleanType) {
                        <mat-checkbox
                          [formControl]="getControl(field.clientKey)">
                          {{ field.name }}
                        </mat-checkbox>
                      }
                      @case (textType) {
                        @if (isAssociationLayout) {
                          <div class="association-field">
                            <label class="association-field__label">{{ getFilterFieldDisplayName(field) }}</label>
                            <mat-form-field appearance="outline" class="filter-field filter-field--association-select">
                              <input matInput type="text" [formControl]="getControl(field.clientKey)" />
                            </mat-form-field>
                          </div>
                        } @else {
                          <mat-form-field appearance="outline" class="filter-field">
                            <mat-label>{{ field.name }}</mat-label>
                            <input matInput type="text" [formControl]="getControl(field.clientKey)" />
                          </mat-form-field>
                        }
                      }
                      @case (singleSelectType) {
                        @if (isAssociationLayout) {
                          <div class="association-field">
                            <label class="association-field__label">{{ getFilterFieldDisplayName(field) }}</label>
                            <mat-form-field appearance="outline" class="filter-field filter-field--association-select">
                              <mat-select
                                [formControl]="getControl(field.clientKey)"
                                [placeholder]="'All ' + getFilterFieldDisplayName(field)">
                                <mat-option [value]="null">All {{ getFilterFieldDisplayName(field) }}</mat-option>
                                @for (option of getSelectOptions(field); track option.value) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        } @else {
                          <mat-form-field appearance="outline" class="filter-field">
                            <mat-label>{{ field.name }}</mat-label>
                            <mat-select [formControl]="getControl(field.clientKey)">
                              <mat-option [value]="null">All {{ field.name }}</mat-option>
                              @for (option of getSelectOptions(field); track option.value) {
                                <mat-option [value]="option.value">
                                  {{ option.label }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        }
                      }
                      @case (multiSelectType) {
                        @if (isAssociationLayout) {
                          <div class="association-field">
                            <label class="association-field__label">{{ getFilterFieldDisplayName(field) }}</label>
                            <mat-form-field appearance="outline" class="filter-field filter-field--association-select">
                              <mat-select [formControl]="getControl(field.clientKey)" multiple>
                                @for (option of getSelectOptions(field); track option.value) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        } @else {
                          <mat-form-field appearance="outline" class="filter-field">
                            <mat-label>{{ field.name }}</mat-label>
                            <mat-select [formControl]="getControl(field.clientKey)" multiple>
                              @for (option of getSelectOptions(field); track option.value) {
                                <mat-option [value]="option.value">
                                  {{ option.label }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        }
                      }
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <div class="active-filters-bar" [class.active-filters-bar--association]="isAssociationLayout">
        @if (hasActiveFilters) {
          <div class="active-filters-bar__chips">
            @for (selection of activeSelections; track selection) {
              <span
                class="filter-chip"
                [style.background]="chipBackground(selection.categoryColor)"
                [style.borderColor]="isAssociationLayout ? null : chipBorder(selection.categoryColor)"
                [style.color]="chipBorder(selection.categoryColor)">
                {{ selection.label }}: {{ selection.displayValue }}
                <button type="button" class="filter-chip__remove" (click)="removeFilter(selection.clientKey)" aria-label="Remove filter">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            }
          </div>
        }
        @if (!isAssociationLayout) {
          <div class="active-filters-bar__summary">
            @if (hasActiveFilters) {
              <span>
                Showing {{ searchSummary.matchingVersions }} of {{ totalVersionCount || searchSummary.matchingVersions }} versions
              </span>
            }
            @if (!hasActiveFilters) {
              <span>Select filters above to preview matching versions</span>
            }
          </div>
        }
        @if (isAssociationLayout && hasActiveFilters) {
          <div class="active-filters-bar__meta">
            <span class="active-filters-bar__match-count">
              {{ searchSummary.matchingVersions }} versions match
            </span>
            <button
              type="button"
              class="clear-all-btn clear-all-btn--link"
              (click)="clearAll()">
              Clear All
            </button>
          </div>
        }
        @if (hasActiveFilters && !isAssociationLayout) {
          <button
            type="button"
            mat-button
            class="clear-all-btn"
            (click)="clearAll()">
            Clear All
          </button>
        }
      </div>
      @if (isAssociationLayout && hasActiveFilters) {
        <div
          class="bulk-select-row"
          [class.bulk-select-row--association]="isAssociationLayout"
          >
          <mat-checkbox
            class="bulk-select-row__full"
            [checked]="allFullMatchesSelected"
            [indeterminate]="someFullMatchesSelected"
            (change)="onSelectAllFullMatchesChange($event.checked)">
            <strong>Select all {{ searchSummary.fullMatch }} full matches</strong>
          </mat-checkbox>
          <mat-checkbox
            class="bulk-select-row__partial"
            [checked]="includePartialMatches"
            (change)="onIncludePartialMatchesChange($event.checked)">
            Include {{ searchSummary.partialMatch }} partial matches
          </mat-checkbox>
        </div>
      }
      @if (hasActiveFilters) {
        @if (!isAssociationLayout) {
          <div class="summary-cards">
            <div class="summary-card">
              <div class="summary-card__value">{{ searchSummary.matchingVersions }}</div>
              <div class="summary-card__label">Matching Versions</div>
            </div>
            <div class="summary-card">
              <div class="summary-card__value">{{ searchSummary.fullMatch }}</div>
              <div class="summary-card__label">Full Match</div>
            </div>
            <div class="summary-card">
              <div class="summary-card__value">{{ searchSummary.partialMatch }}</div>
              <div class="summary-card__label">Partial Match</div>
            </div>
            <div class="summary-card">
              <div class="summary-card__value">{{ searchSummary.totalStores }}</div>
              <div class="summary-card__label">Total Stores</div>
            </div>
          </div>
        }
        <div class="results-section" [class.results-section--association]="isAssociationLayout">
          @if (!isAssociationLayout) {
            <div class="results-section__header">
              <h4 class="results-section__title">{{ filteredResultsTitle }}</h4>
              <span class="results-section__sort">Sorted: full matches first</span>
            </div>
          }
          @if (attributeSearchLoading) {
            <p class="results-loading">Loading matching versions...</p>
          }
          <ng-template #resultRow let-result>
            <div
              class="result-row"
              [class.result-row--association]="isAssociationLayout"
              [class.result-row--selected]="isAssociationLayout && isVersionSelected(result.versionName)"
              [class.result-row--partial]="isAssociationLayout && result.matchType === 'partial'"
              [class.result-row--disabled]="isAssociationLayout && !isRowSelectable(result)">
              <mat-checkbox
                class="result-row__checkbox"
                [checked]="isAssociationLayout && isVersionSelected(result.versionName)"
                [disabled]="!isAssociationLayout || !isRowSelectable(result)"
                (change)="onVersionCheckboxChange(result, $event.checked)">
              </mat-checkbox>
              @if (isAssociationLayout) {
                <span
                  class="conflict-icon"
                  [class.conflict-icon--ok]="result.matchType === 'full'"
                  [class.conflict-icon--warn]="result.matchType === 'partial'"
                  [matTooltip]="getMatchTooltip(result)"
                  matTooltipPosition="above">
                  {{ result.matchType === 'full' ? '✓' : '!' }}
                </span>
              }
              @if (!isAssociationLayout) {
                <mat-icon
                  class="result-row__match-icon"
                  [class.result-row__match-icon--full]="result.matchType === 'full'">
                  {{ result.matchType === 'full' ? 'check_circle' : 'adjust' }}
                </mat-icon>
              }
              <div class="result-row__content">
                <div class="result-row__name">{{ result.versionName }}</div>
                <div class="result-row__tags">
                  @for (tag of result.inheritedAttributes; track tag) {
                    <span
                      class="attribute-tag"
                      [class.attribute-tag--association]="isAssociationLayout"
                      [style.background]="tag.categoryColorHex + '1a'"
                      [style.borderColor]="tag.categoryColorHex"
                      [style.color]="tag.categoryColorHex">
                      {{ formatTagLabel(tag) }}
                    </span>
                  }
                </div>
              </div>
              <div class="result-row__meta">
                <span class="result-row__stores">{{ result.storeCount }} stores</span>
                @if (isAssociationLayout && result.matchType === 'partial') {
                  <span
                    class="result-row__match"
                    [class.result-row__match--partial]="result.matchType === 'partial'">
                    {{ result.matchPercent }}% match
                  </span>
                }
                @if (!isAssociationLayout) {
                  <span
                    class="result-row__match"
                    [class.result-row__match--full]="result.matchType === 'full'">
                    {{ result.matchPercent }}% match
                  </span>
                }
              </div>
            </div>
          </ng-template>
          @if (!attributeSearchLoading) {
            <div class="results-list">
              @if (!isAssociationLayout) {
                @for (result of apiResults; track result.versionName) {
                  <ng-container *ngTemplateOutlet="resultRow; context: { $implicit: result }"></ng-container>
                }
              }
              @if (isAssociationLayout) {
                @for (result of fullMatchResults; track result.versionName) {
                  <ng-container *ngTemplateOutlet="resultRow; context: { $implicit: result }"></ng-container>
                }
                @if (partialMatchResults.length) {
                  <div class="partial-matches-separator">
                    Partial Matches - cross-state or mixed-capability versions
                  </div>
                }
                @for (result of partialMatchResults; track result.versionName) {
                  <ng-container *ngTemplateOutlet="resultRow; context: { $implicit: result }"></ng-container>
                }
              }
            </div>
          }
        </div>
      }
      @if (isAssociationLayout && !hasActiveFilters) {
        <p class="no-filters-message">
          Select filters above to find matching versions.
        </p>
      }
    }
  } @else {
    @if (!categoriesLoading && !categoriesLoadError) {
      <p class="no-filters-message">
        No store attributes are enabled for filtering. Enable filters in Store Attribute Types administration.
      </p>
    }
  }

</section>
